import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ThunderIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.6577 8.91604C15.703 8.96446 15.7328 9.02534 15.7432 9.09083C15.7537 9.15633 15.7443 9.22344 15.7162 9.28354L11.196 18.969C11.1525 19.0507 11.0819 19.1146 10.9963 19.1498C10.9107 19.185 10.8156 19.1892 10.7272 19.1618C10.5435 19.1018 10.4347 18.927 10.476 18.7508L12.126 11.9873L8.72697 12.8333C8.69322 12.8408 8.65947 12.8408 8.62647 12.8408C8.53199 12.8412 8.4403 12.8089 8.36697 12.7493C8.32047 12.7103 8.28569 12.6591 8.26649 12.6015C8.24729 12.5439 8.24443 12.4822 8.25822 12.423L9.94122 5.51704C9.96424 5.43805 10.0128 5.36893 10.0793 5.32048C10.1458 5.27203 10.2265 5.247 10.3087 5.24929H13.0552C13.2652 5.24929 13.4317 5.40829 13.4317 5.60179C13.4295 5.65436 13.4151 5.7057 13.3897 5.75179L11.9587 9.62704L15.2737 8.80654C15.3062 8.79704 15.3397 8.7915 15.3735 8.79004C15.4822 8.79004 15.5827 8.84104 15.6577 8.91604Z'
                fill='currentColor'
            />
        </>
    ),
})

ThunderIcon.displayName = 'ThunderIcon'
